import React from 'react';
import { connect } from 'react-redux';


import { addCTOToCart } from '../../utility/utility-actions';
import { withError } from '../../shared/components/error-boundary';
import withWindowResize from '../../ui/components/window-resize';
import { getCTOLink } from './purchase-button';

import '../css/cto-add-to-cart.less';

class CTOAddToCart extends React.PureComponent {
    static defaultProps = {
        mobileOnly: true,
        mobileSpacer: true
    }

    state = {
        btnBusy: false
    }

    purchaseCTO = (quantity = 1) => {
        const { product } = this.props;
        this.props.addCTOToCart(product, quantity, true);
    }

    btnClick = () => {
        return () => {
            this.setState({
                btnBusy: true
            }, () => {
                setTimeout(this.purchaseCTO, 0);
            })
        }
    }

    render() {
        const { mobileOnly, device, eligibleSku, itemId, mobileSpacer, product } = this.props;
        const { attributes = {} } = product;
        const { ctoAddToCart } = attributes;

        if ((mobileOnly && device !== 'mobile') || !ctoAddToCart || !product) {
            return null;
        }
        return (
            <div className='cto-add-to-cart'>
                {mobileSpacer && <div className="cto-mobile-spacer">{" or "}</div>}
                <div className={`btn${this.state.btnBusy ? ' busy' : ''}`} onClick={this.btnClick()}>
                    {"ADD TO CART"}
                </div>
                <div className="preconfig-disclaimer">
                    {" Pre-configurated for you! "}
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addCTOToCart: (product, quantity, blockFlyout) => dispatch(addCTOToCart(product, quantity, blockFlyout))
    };
};

export default connect(null, mapDispatchToProps)(withError(withWindowResize(CTOAddToCart)));

